/* First-party form confirmation bridge. No Google tag and no customer form values. */
(() => {
  if (window.skLeadBridge) return;
  window.skLeadBridge = true;
  window.skLeadStatus = 'Venter på skjemainnsending';
  const PREFIX = 'sk-lead-v1:';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(PREFIX + key)); } catch { return null; } };
  const remove = key => { try { sessionStorage.removeItem(PREFIX + key); } catch {} };
  const write = (key, data) => { try { sessionStorage.setItem(PREFIX + key, JSON.stringify(data)); return true; } catch { return false; } };
  const keyFor = form => location.pathname + ':' + form.id;
  const markerFor = form => form.querySelector('[data-sk-lead-form]');
  const config = node => { try { return JSON.parse(node.textContent); } catch { return null; } };
  function rememberAttempt(form) {
    if (!(form instanceof HTMLFormElement) || form.querySelector('[name="form_type"]')?.value !== 'contact') return;
    const marker = markerFor(form), data = marker && config(marker);
    if (!data || !form.id) return;
    const key = keyFor(form);
    if (!allowed()) { remove(key); window.skLeadStatus='Analyse er ikke tillatt eller samtykke-API mangler'; return; }
    // Captcha may stop submit propagation and later call native form.submit().
    // Remember intent before that interception; never publish until server success.
    if (!form.checkValidity()) return;
    window.skLeadStatus='Innsendingsforsøk registrert; venter på Shopify-bekreftelse';
    const origin = read('origin');
    const product = data.product_id ? data : (origin && Date.now()-origin.time < 1800000 ? origin : data);
    write(key, {time:Date.now(), token:crypto.randomUUID(), lead_type:data.lead_type,
      product_id:product.product_id || '', variant_id:product.variant_id || '', product_sku:product.product_sku || '',
      page_location:location.origin + location.pathname, journey:window.skSolarJourney?.snapshot() || null});
  }
  document.addEventListener('submit', event => rememberAttempt(event.target), true);
  document.addEventListener('click', event => {
    const button = event.target.closest('button, input[type=submit], input[type=image]');
    if (button && button.type === 'submit' && button.form) rememberAttempt(button.form);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target instanceof HTMLInputElement) rememberAttempt(event.target.form);
  }, true);
  // Optional marked links preserve product context when opening a contact page in the same tab.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sk-lead-link]');
    if (!link || !allowed()) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    write('origin', {time:Date.now(), product_id:link.dataset.productId || '', variant_id:link.dataset.variantId || '', product_sku:link.dataset.productSku || ''});
  });
  function confirm() {
    if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    document.querySelectorAll('[data-sk-lead-form]').forEach(marker => {
      const data=config(marker), form=marker.closest('form');
      if (!data?.success || !form?.id || form.querySelector('[name="form_type"]')?.value !== 'contact') return;
      const key=keyFor(form), pending=read(key);
      if (!pending || Date.now()-pending.time > 1800000 || Date.now()<pending.time) {remove(key);return;}
      // Consume before publish: reloads and multiple success markers cannot count twice.
      remove(key); remove('origin');
      window.skLeadStatus='Shopify-bekreftelse funnet; publiserer lead';
      window.skSolarJourney?.confirmed(pending.journey,pending.token);
      window.Shopify.analytics.publish('stromkilden:lead_confirmed', {
        lead_id:pending.token, lead_type:pending.lead_type, form_id:form.id,
        product_id:pending.product_id, variant_id:pending.variant_id, product_sku:pending.product_sku,
        page_location:pending.page_location
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',confirm); else confirm();
  document.addEventListener('visitorConsentCollected',confirm);
  // Shopify may initialize after the deferred asset. Stop polling after ten seconds.
  // Ensure the consent API is loaded; absence must never be treated as consent.
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {
    if(error) window.skLeadStatus='Samtykke-API kunne ikke lastes';
    else confirm();
  });
  let tries=0; const timer=setInterval(()=>{confirm();if(++tries===20)clearInterval(timer);},500);
})();
